import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import SrcSize from 'components/ui/SrcSize/SrcSize'
import { MenuLink } from 'components/_new/ui/Menu'

import s from './Collection.scss'


class HeaderSubNavDropdownCollectionsCollection extends PureComponent {

  static propTypes = {
    collection: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      image: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
  }

  handleClick = (event) => {
    const { collection, onClick } = this.props

    onClick(event, collection)
  }

  render() {
    const { collection, _ref, state, setState } = this.props

    return (
      <MenuLink
        className={s.collection}
        to={collection.url}
        index={collection.adaIndex}
        customColor
        onClick={this.handleClick}
        {...{ _ref, state, setState }}
      >
        <div className={s.imageContainer}>
          <SrcSize src={collection.image} w={200}>
            {(src) => (
              <div className={s.image} style={{ backgroundImage: `url(${src})` }} />
            )}
          </SrcSize>
        </div>
        <div className={s.title}>{collection.title}</div>
      </MenuLink>
    )
  }
}


export default HeaderSubNavDropdownCollectionsCollection
